<template>
  <div class="formula-wrap">
    <el-tabs
      tab-position="left"
      style="height: 100%"
      v-if="expression && expression.expressionGroups"
      @tab-click="tabClick"
    >
      <el-tab-pane
        v-for="(obj, index) in expression.expressionGroups"
        :key="index"
        :label="obj.displayName"
        :icIndex="index"
      >
        <div class="yr">
          <el-button type="primary" @click="introduced()">批量引入</el-button>
        </div>
        <div style="width: calc(100% - 0px); height: 600px">
          <nk-table
            :columns="columns"
            :showIndex="true"
            noDataTitle="暂无测量数据"
            :data="obj.expression"
          >
            <el-table-column
              slot="operation"
              label="操作"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="editComputed(scope.row, scope.$index)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </nk-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 修改计算公式 -->
    <el-dialog
      title="修改计算公式"
      :visible.sync="visibleParam"
      :close-on-click-modal="false"
      :modal="false"
    >
      <el-form
        ref="paramInfo"
        :rules="rules"
        style="max-height: 550px; overflow: auto"
        :model="paramInfo"
        label-width="120px"
      >
        <el-form-item label="名称" prop="name">
          <el-input disabled v-model="paramInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="显示名称" prop="displayName">
          <el-input disabled v-model="paramInfo.displayName"></el-input>
        </el-form-item>
        <el-form-item label="测量编码" prop="pointCodeName">
          <el-input disabled v-model="paramInfo.pointCodeName"></el-input>
        </el-form-item>
        <el-form-item label="测量编号" prop="pointNumber">
          <el-input v-model="paramInfo.pointNumber"></el-input>
        </el-form-item>
        <el-form-item label="是否引用">
          <el-switch
            v-model="paramInfo.measuringByReference"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item
          label="计量值转换公式"
          v-show="paramInfo.measuringByReference == '0'"
        >
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="paramInfo.expressionForChangingValue"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="测量值挑选表达式"
          v-show="paramInfo.measuringByReference == '0'"
        >
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="paramInfo.expressionForChoosingPoints"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="引用测量点"
          v-show="paramInfo.measuringByReference == '1'"
        >
          <!-- <el-select v-model="paramInfo.referenceMeasureId">
            <el-option
              v-for="(item,index) in containersItem"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>-->
          <label>{{ paramInfo.referenceMeasureName }}</label>
          <el-button type="text" @click="bindShowSelect">选择测量点</el-button>
        </el-form-item>
        <el-form-item
          label="引用测量点编码"
          v-show="paramInfo.measuringByReference == '1'"
        >
          <el-select v-model="paramInfo.referencePointCode">
            <el-option
              v-for="(item, index) in codeData"
              :key="index"
              :value="parseInt(item.code)"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="引用测量点编号"
          v-show="paramInfo.measuringByReference == '1'"
        >
          <el-input v-model="paramInfo.referencePointNumber"></el-input>
        </el-form-item>
        <el-form-item label="是否由系统计算">
          <el-switch
            v-model="paramInfo.calculateBySystem"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            style="width: 100%"
            v-model="paramInfo.startTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            style="width: 100%"
            v-model="paramInfo.endTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveComputed">确 定</el-button>
        <el-button @click="visibleParam = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 修改计算公式 -->
    <el-dialog
      :title="isEdit ? '更换测量点' : '批量引入'"
      :visible.sync="showIntroduced"
      width="600px"
      :modal="false"
    >
      <!-- :close-on-click-modal="false" -->
      <el-form
        ref="introcForm"
        :rules="rules"
        style="max-height: 550px; overflow: auto"
        :model="introcForm"
        label-width="120px"
      >
        <div
          style="width: 300px; padding-bottom: 20px; margin: 0px auto"
          v-if="!isEdit"
        >
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <el-checkbox-group
            style="display: flex; flex-wrap: wrap"
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox
              v-for="(item, index) in groupData"
              :label="item.id"
              :key="index"
              >{{ item.displayName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <el-form-item label="引用方式:">
          <el-select style="width: 240px" v-model="userType">
            <el-option value="1" label="通过容器"></el-option>
            <el-option value="2" label="通过对象"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="容器:" v-show="userType == '1'">
          <el-select
            style="width: 240px"
            v-model="rqName"
            @change="changeMeasure"
            :disabled="showDis"
            clearable
          >
            <el-option
              v-for="(item, index) in containers"
              :key="index"
              :value="item.name"
              :label="item.displayName"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="计量点:" v-show="userType == '1'">
          <el-select
            style="width: 240px"
            v-model="measureIds"
            :disabled="showDis"
            clearable
          >
            <el-option
              v-for="(item, index) in containersItem"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计量点:" v-show="userType == '2'">
          <label v-if="selectedItem">{{ selectedItem.measureName }}</label>
          <el-button type="text" @click="showVisible">选择计量点</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveIntroduced">确 定</el-button>
        <el-button @click="showIntroduced = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 新增测量点 -->
    <div>
      <el-dialog
        title="选择测量点"
        :visible.sync="visible"
        width="500px"
        :close-on-click-modal="false"
        :modal="false"
      >
        <div style="padding: 6px; background: #00388c; color: #fff">
          对象列表：
          <el-select
            style="width: 140px"
            size="mini"
            v-model="objId"
            @change="objChange"
          >
            <el-option
              v-for="(item, index) in objData"
              :key="index"
              :value="item.id"
              :label="item.displayName"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText"
          ></el-input>
        </div>
        <div style="width: 100%; height: 200px; overflow: auto">
          <el-tree
            ref="pointTree"
            :data="treeData"
            node-key="id"
            :props="defaultProps"
            :filter-node-method="filterNode"
            @node-click="nodeClick"
          ></el-tree>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import api from "@common/api/index.js";
import dateTool from "@/utils/dateTool";
import NkTable from "@/components/common/NkTable";
import tree from "@/utils/tree";
export default {
  components: { NkTable },
  props: {
    measureId: {
      type: String,
      default: "",
    },
  },
  watch: {
    measureId(val) {
      this.getData(val);
    },
    filterText(val) {
      this.$refs.pointTree.filter(val);
    },
  },
  data() {
    return {
      expression: null,
      visibleParam: false,
      paramInfo: {},
      selectedParam: null,
      rules: {},
      columns: [
        { prop: "name", label: "名称", show: true },
        { prop: "displayName", label: "显示名称", show: true },
        { prop: "pointCodeName", label: "测量编码", show: true },
        { prop: "pointNumber", label: "测量编号", show: true },
        { prop: "operation", slot: "operation", label: "操作", show: true },
      ],
      codeData: window.baseConfig.collectData,
      showIntroduced: false,
      introcForm: {},
      groupData: [],
      icIndex: "",
      icIndex1: 0,
      checkedCities: [],
      checkAll: false,
      isIndeterminate: true,
      // containers: [], //容器
      // containersItem: [], //容器
      measureIds: null, //测量点
      rqName: null,
      showDis: false,
      userType: "1",
      visible: false,
      objData: [],
      objId: "",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "measureName",
      },
      selectedItem: null,
      filterText: "",
      isEdit: false,
    };
  },
  created() {
    this.getData(this.measureId);
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.measureName.indexOf(value) !== -1;
    },
    getData(id) {
      let vm = this;
      api.measure
        .getUniqueMeasuresExpressions(JSON.stringify([id]))
        .then((res) => {
          if (res.data.length == 0) {
            return;
          }
          let obj = res.data[0];
          //排序
          obj.expressionGroups.sort(function(a, b) {
            return a.orderNum - b.orderNum;
          });
          for (let index = 0; index < obj.expressionGroups.length; index++) {
            obj.expressionGroups[index].expression.sort(function(a, b) {
              return a.orderNum - b.orderNum;
            });
            for (
              let j = 0;
              j < obj.expressionGroups[index].expression.length;
              j++
            ) {
              const element = obj.expressionGroups[index].expression[j];
              const codeItem = vm.codeData.find(
                (k) => k.code == element.pointCode
              );
              obj.expressionGroups[index].expression[j].pointCodeName = codeItem
                ? codeItem.name
                : element.pointCode;
            }
          }
          vm.expression = obj;
          vm.groupData = obj.expressionGroups[vm.icIndex1].expression;
          vm.checkedCities = [];
          vm.groupData.forEach((item) => {
            if (item.measuringByReference == 1) {
              vm.checkedCities.push(item.id);
            }
          });
          // api.measure
          //   .getDirectSubNode(id, JSON.stringify([]))
          //   .then((res) => {
          //     vm.containers = res.data;
          //     if (res.data.length > 0) {
          //       vm.containersItem = res.data[0].items;
          //     }
          //   });
        });
    },
    async editComputed(item) {
      let vm = this;
      let obj = JSON.parse(JSON.stringify(item));
      if (!obj.measuringByReference) {
        obj.measuringByReference = "0";
      }
      if (obj.referenceMeasureId) {
        const measure = await api.measure.getMeasuresInfo(
          JSON.stringify([obj.referenceMeasureId])
        );
        if (measure.data && measure.data.length > 0) {
          obj.referenceMeasureName = measure.data[0].name;
        }
      }
      vm.selectedParam = obj;
      vm.paramInfo = obj;
      vm.visibleParam = true;
    },
    bindShowSelect() {
      let vm = this;
      vm.selectedItem = null;
      vm.isEdit = true;
      vm.showIntroduced = true;
    },
    saveComputed() {
      let vm = this;
      let startTime =
          vm.paramInfo.startTime && vm.paramInfo.startTime !== ""
            ? dateTool.format(vm.paramInfo.startTime, "yyyy-MM-dd hh:mm:ss")
            : "",
        endTime =
          vm.paramInfo.endTime && vm.paramInfo.endTime !== ""
            ? dateTool.format(vm.paramInfo.endTime, "yyyy-MM-dd hh:mm:ss")
            : "";
      api.measure
        .modifyMeasuringExpression(
          vm.paramInfo.id,
          vm.paramInfo.pointCode,
          vm.paramInfo.pointNumber,
          vm.paramInfo.expressionForChangingValue,
          vm.paramInfo.expressionForChoosingPoints,
          vm.paramInfo.measuringByReference,
          vm.paramInfo.referenceMeasureId,
          vm.paramInfo.referencePointCode,
          vm.paramInfo.referencePointNumber,
          vm.paramInfo.calculateBySystem,
          startTime,
          endTime
        )
        .then((res) => {
          if (res.success) {
            vm.$message("修改成功！");
            vm.selectedParam.pointNumber = vm.paramInfo.pointNumber;
            vm.selectedParam.expressionForChangingValue =
              vm.paramInfo.expressionForChangingValue;
            vm.selectedParam.expressionForChoosingPoints =
              vm.paramInfo.expressionForChoosingPoints;
            vm.selectedParam.startTime = startTime;
            vm.selectedParam.endTime = endTime;
            vm.getData(vm.measureId);
            vm.visibleParam = false;
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
    tabClick(row) {
      let i = Number(row.index);
      this.icIndex1 = i;
      this.groupData = this.expression.expressionGroups[i].expression;
      this.checkedCities = [];
      this.groupData.forEach((item) => {
        if (item.measuringByReference == 1) {
          this.checkedCities.push(item.id);
        }
      });
    },
    //批量引入
    introduced() {
      let vm = this;
      vm.showDi = false;
      if (vm.checkedCities.length == 0) {
        vm.showDis = true;
      }
      vm.measureIds = null; //测量点
      vm.rqName = null;
      vm.showIntroduced = true;
    },
    handleCheckedCitiesChange(value) {
      let vm = this;
      this.checkedCities = value;
      vm.showDis = true;
      if (value.length > 0) {
        vm.showDis = false;
      }
    },
    //容器切换
    // changeMeasure(val) {
    //   let vm = this;
    //   vm.containers.forEach((item) => {
    //     if (item.name == val) {
    //       vm.containersItem = item.items;
    //     }
    //   });
    // },
    //批量保存
    saveIntroduced() {
      let vm = this;
      if (vm.isEdit) {
        let referenceMeasure = null;
        if (vm.userType == "1") {
          referenceMeasure = vm.containersItem.find(
            (c) => c.id == vm.measureIds
          );
        } else {
          referenceMeasure = vm.selectedItem
            ? {
                id: vm.selectedItem.measureId,
                name: vm.selectedItem.measureName,
              }
            : null;
        }

        if (!referenceMeasure || typeof referenceMeasure == "undefined") {
          vm.$message({
            message: "请选择计量点",
            type: "warning",
          });
          return;
        }
        vm.paramInfo.referenceMeasureId = referenceMeasure.id;
        vm.paramInfo.referenceMeasureName = referenceMeasure.name;
        vm.showIntroduced = false;
        vm.isEdit = false;
        return;
      }
      if (vm.checkedCities.length > 0) {
        if (!vm.measureIds) {
          vm.$message({
            message: "请选择计量点",
            type: "warning",
          });
          return;
        }
      }
      let apiArr = [];
      vm.groupData.forEach((item) => {
        let noneItem = {};
        vm.checkedCities.forEach((k) => {
          if (k == item.id) {
            // vm.modifyMeasuringExpression(item, 1, vm.measureIds);
            apiArr.push(
              api.measure.modifyMeasuringExpression(
                item.id,
                item.pointCode,
                item.pointNumber,
                item.expressionForChangingValue,
                item.expressionForChoosingPoints,
                1,
                vm.measureIds ? vm.measureIds : "", //引入的计量点
                item.pointCode,
                item.pointNumber,
                item.calculateBySystem,
                item.startTime,
                item.endTime
              )
            );
          }
        });
      });

      Promise.all(apiArr).then((resArr) => {
        let bol = false;
        for (let index = 0; index < resArr.length; index++) {
          if (!resArr[index].success) {
            bol = true;
            vm.$message.error(resArr[index].msg);
          }
        }
        if (bol == false) {
          vm.$message("修改成功！");
          vm.showIntroduced = false;
          vm.getData(vm.measureId);
        }
      });
    },
    handleCheckAllChange(val) {
      let checkedCities = [];
      for (let index = 0; index < this.groupData.length; index++) {
        checkedCities.push(this.groupData[index].id);
      }
      this.checkedCities = val ? checkedCities : [];
      this.isIndeterminate = false;
    },
    //引入点修改
    modifyMeasuringExpression(temp, referenceMeasureId, measureIds) {
      let vm = this;
      let startTime =
          temp.startTime && temp.startTime !== ""
            ? dateTool.format(temp.startTime, "yyyy-MM-dd hh:mm:ss")
            : "",
        endTime =
          temp.endTime && temp.endTime !== ""
            ? dateTool.format(temp.endTime, "yyyy-MM-dd hh:mm:ss")
            : "";
      api.measure
        .modifyMeasuringExpression(
          temp.id,
          temp.pointCode,
          temp.pointNumber,
          temp.expressionForChangingValue,
          temp.expressionForChoosingPoints,
          referenceMeasureId == null ? referenceMeasureId : "",
          measureIds ? measureIds : "", //引入的计量点
          temp.pointCode,
          temp.pointNumber,
          temp.calculateBySystem,
          startTime,
          endTime
        )
        .then((res) => {
          if (res.success) {
            vm.$message("修改成功！");
            vm.showIntroduced = false;
            vm.getData(vm.measureId);
          } else {
            vm.$message.error(res.msg);
          }
        });
    },
    showVisible() {
      let vm = this;
      vm.getCompanyViewTreesInfo();
      vm.visible = true;
    },
    objChange(val) {
      this.getViewTreeNodes(val);
    },
    async getCompanyViewTreesInfo() {
      let vm = this;
      await api.view
        .getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res) {
            vm.objData = res.data;
            if (res.data.length > 0) {
              vm.objId = res.data[0].id;
              vm.getViewTreeNodes(vm.objId);
            }
          }
        });
    },
    async getViewTreeNodes(id) {
      await api.view.getViewTreeNodes(id).then((res) => {
        let data = tree.creatTreeJson(res.data, 0);
        this.treeData = data;
      });
    },
    nodeClick(data) {
      let vm = this;
      vm.selectedItem = data;
      vm.measureIds = data.measureId;
      vm.visible = false;
      // vm.addItem(vm.selectKey, data);
    },
  },
};
</script>

<style lang="scss" scoped>
.formula-wrap {
  width: 100%;
  margin: 0px auto;
  height: 100%;
}
.param-item {
  padding: 10px 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  .param-item-left {
    flex: 1;
    text-align: left;
    .icon {
      padding: 0px 10px;
    }
  }
  .param-item-check {
    flex: 0 0 100px;
  }
  .param-item-btn {
    flex: 0 0 180px;
    text-align: right;
    .btn-icon {
      font-size: 18px;
      padding: 0px 10px;
    }
  }
  .table {
    width: 100%;
    border: 1px solid #dcdfe6;
    border-color: #dcdfe6;
    border-collapse: collapse;
    tr td {
      height: 30px;
    }
    tr td:first-child {
      width: 140px;
      text-align: right;
    }
    .formula td {
      height: 60px;
    }
  }
}
</style>
<style lang="scss">
.right-content .el-tabs__content {
  overflow: auto;
  height: calc(100% - 60px);
}
.yr {
  text-align: right;
  margin-bottom: 5px;
}
</style>
